/* eslint-disable no-shadow */
const React = require('react');
const { wrapFunctionalComponent } = require('utils/framework').default;
const getBaseComponent = require('utils/framework/getBaseComponent').default;
const getStyledComponent = require('utils/framework/getStyledComponent').default;
const {
    compose, border, color, flexbox, layout, position, typography, shadow, space, system
} = require('styled-system');
const grid = require('style/grid');
const inset = require('style/inset');

const scrollPadding = system({
    scrollPadding: {
        property: 'scrollPadding',
        scale: 'space'
    }
});

const theme = require('style/theme');
const uiUtils = require('utils/UI');

const StyledComponent = getStyledComponent({
    InnerComp: getBaseComponent({
        elementType: 'div',
        isBasicElement: false,
        useRef: true
    }),
    styledProps: [
        props => [props.baseCss, compose(border, color, flexbox, grid, inset, layout, position, typography, shadow, space, scrollPadding), props.css]
    ]
});

const Box = React.forwardRef((props, ref) => {
    return (
        <StyledComponent
            __ref={ref}
            {...props}
            {...uiUtils.getAriaButtonProps('div', props)}
        />
    );
});

Box.defaultProps = {
    theme,
    display: 'block'
};

module.exports = wrapFunctionalComponent(Box, 'Box');
